import Axios, { AxiosResponse } from 'axios';
import * as XmlParser from 'xml-js';
import Strings from '../translations/strings';

export function getRssFeed<TResult extends object>(
    successCallback: (result: any) => void,
    errorCallback: (error: any) => void
) {
    const address = Strings.components.rssFeed.feedLink;
    Axios.get(address)
        .then((response: AxiosResponse) => {
            if (response.status === 200) {
                const data: TResult = JSON.parse(XmlParser.xml2json(response.data, { compact: true }));
                successCallback(data);
            } else {
                console.error('eWay WS get response error: ' + JSON.stringify(response));
                errorCallback(response);
            }
        })
        .catch((error) => {
            console.error('eWay WS get request failed: ' + error);
            errorCallback(error);
        });
}
